module.exports = __webpack_public_path__ + "img/opensea_s.8f16ee64.png";